export class AdminAllPaymentHistory {
    uid: number;
    amountTotal: number;
    amount: number;
    tax: number;
    recordCount: number;
    businessName: string;
    email: string;
    status: string;

    constructor(
        uid: number,
        amountTotal: number,
        amount: number,
        tax: number,
        recordCount: number,
        businessName: string,
        email: string,
        status: string
    ) {
        this.uid = uid;
        this.amountTotal = amountTotal;
        this.amount = amount;
        this.tax = tax;
        this.recordCount = recordCount;
        this.businessName = businessName;
        this.email = email;
        this.status = status;
    }
}

export class AdminUserPaymentHistory {
    stripeAmount: number;
    dbAmount: number;
    records: AdminUserPaymentHistoryRecord[];
    
    constructor(
        stripeAmount: number,
        dbAmount: number,
        records: AdminUserPaymentHistoryRecord[]
    ) {
        this.stripeAmount = stripeAmount;
        this.dbAmount = dbAmount;
        this.records = records;
    }
}

export class AdminUserPaymentHistoryRecord {
    message: string;

    status?: string;
    stripeStatus?: string;

    amountTotal?: number;
    amount?: number;
    tax?: number;
    created?: number;

    stripeAmountTotal?: number;
    stripeCurrency?: string;
    stripeReceiptUrl?: string;
    stripeCreated?: number;

    constructor(
        message: string,
        status?: string,
        stripeStatus?: string,
        amountTotal?: number,
        amount?: number,
        tax?: number,
        created?: number,
        stripeAmountTotal?: number,
        stripeCurrency?: string,
        stripeReceiptUrl?: string,
        stripeCreated?: number,
    ) {
        this.message = message;
        this.status = status;
        this.stripeStatus = stripeStatus;
        this.amountTotal = amountTotal;
        this.amount = amount;
        this.tax = tax;
        this.created = created;
        this.stripeAmountTotal = stripeAmountTotal;
        this.stripeCurrency = stripeCurrency;
        this.stripeReceiptUrl = stripeReceiptUrl;
        this.stripeCreated = stripeCreated;
    }
}
